import React, { Dispatch } from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  downloadDocDetails: any;
  setDownloadDocDetails: Dispatch<any>;
};

export const DownloadDocFileMsg: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  downloadDocDetails,
  setDownloadDocDetails,
}) => {

  const downloadAttachment = async () => {
    if(downloadDocDetails){
      let documentBlob = await fetch(downloadDocDetails.docURL).then(
        (r) => r.blob()
      );
      const downloadUrl = window.URL.createObjectURL(
        new Blob([documentBlob])
      );
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute(
        'download',
        `${downloadDocDetails.fileName}${downloadDocDetails.docExt}`
      );
      document.body.appendChild(link);

      link.click();
      setTimeout(function () {
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
        setDownloadDocDetails(null);
        document.body.style.overflowY = '';
        togglePanelOpen(false);
      }, 100);
    }
  };

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={"No Preview Available"}
      position="right"
      givenClass="DownloadDocFileMsg"
      noFooter={true}
      handleClose={() => togglePanelOpen(false)}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={560}
    >
      <p>This file doesn't have a preview we can show you.</p>

      <div className="LineSpacer4"></div>

      <div 
        className="Btn BtnOrange" 
        style={{ width: "100%" }}
        onClick={() => downloadAttachment()}
      >
        <span>Download Attachment</span>
      </div>
    </PopupOrPanel>
  );
};
